import React, { Component } from 'react';

import WideCard from './components/WideCard/WideCard';
import CtaCard from './components/CtaCard/CtaCard';

const imgSrcDir = '/Static/prod/images/careers-page';

const heroImg = `${imgSrcDir}/hero.png`;
const positionsImg = `${imgSrcDir}/positions.png`;

const waterproofImg = `${imgSrcDir}/waterproof.png`;
const raaLabsImg = `${imgSrcDir}/raa-labs.png`;
const printing3DImg = `${imgSrcDir}/printing-3d.png`;

const raaEdgeLogo = `${imgSrcDir}/raa-edge-logo.png`;
const lmpLogo = `${imgSrcDir}/lmp-logo.png`;
const sparkLogo = `${imgSrcDir}/spark-logo.png`;
const printing3DLogo = `${imgSrcDir}/printing-3d-logo.png`;
const nextOneLogo = `${imgSrcDir}/next-one-logo.png`;

const firstPersonImg = `${imgSrcDir}/kristoffer-bilde.png`;
const secondPersonImg = `${imgSrcDir}/emil-ramsvik.png`;
const thirdPersonImg = `${imgSrcDir}/marita-lindstrom.png`;
const fourthPersonImg = `${imgSrcDir}/daniel-tan.png`;

const galleryImageOne = `${imgSrcDir}/gallery-image-1.jpg`;
const galleryImageTwo = `${imgSrcDir}/gallery-image-2.jpg`;
const galleryImageThree = `${imgSrcDir}/gallery-image-3.jpg`;
const galleryImageFour = `${imgSrcDir}/gallery-image-4.jpg`;

const officeImg = `${imgSrcDir}/office.png`;

export default class CareersPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="careers-page" id="careers-page">
        <div
          className="careers-page__hero"
          style={{ backgroundImage: `url(${heroImg})` }}
        >
          <h1>
            Welcome to the
            <br />
            Wilhelmsen digital hub
          </h1>
        </div>
        <div className="careers-page__hero-subcontent">
          <p>
            Around for 160 years, our continued success is based on our ability
            to consistently innovate, and finding new solutions to often age-old
            maritime problems. Whether it's creating a digital archive and
            delivery platform for complex 3D printed parts, solving the various
            connectivity and data monitoring challenges onboard, and lots more,
            we are shaping the maritime industry for the future.
          </p>
        </div>
        <div
          className="careers-page__positions"
          style={{ backgroundImage: `url(${positionsImg})` }}
        >
          <div className="careers-page__positions-cta">
            <h2>Join us!</h2>
            <button
              className="cta-btn"
              onClick={() =>
                window.open(
                  'https://wilhelmsen.wd3.myworkdayjobs.com/Wilhelmsen',
                  '_blank'
                )
              }
              type="button"
            >
              View open positions
            </button>
            <p>or reach out to <a href="mailto:digitalcareer@wilhelmsen.com">digitalcareer@wilhelmsen.com</a> to learn more</p>
          </div>
        </div>
        <div className="careers-page__info-headline">
          <h2>Short case studies - some of our innovative digital products</h2>
        </div>
        <div className="careers-page__info-cards">
          <WideCard
            image={waterproofImg}
            alt="Ship on the ocean"
            heading="Waterproof - digital onboard water management"
            problemText="About 10 years ago, Wilhelmsen launched a highly innovative maritime product called Waterproof.
              As a software and support system that keeps track of important onboard water system data, Waterproof made the manual,
              imprecise and difficult task it was to measuring water quality into a reliable and safe exercise thanks to
              our digital and innovative mindset. 10 years for a product is a long time. How do we replace this legacy system,
              that is used for critical operations onboard, with a new and updated version without causing interruption for the thousands of users?"
            solutionText="With 10 years of learnings, our long list of improvements and features help us build the next version
              of Waterproof, lifting the product fully into the digital world. This means a full rewrite to ensure it can support
              the world fleet with precise and reliable water treatment advice for at least another decade. We are going from
              a hybrid solution to a pure software as a service (SaaS) application, developed as a web application.
              Vessels are getting more connected,and this opens an opportunity space for our application that we will fully take advantage of."
          />
          <WideCard
            image={raaLabsImg}
            alt="Ship on the ocean"
            heading="Raa Labs - vessel data as a service"
            problemText="Viking Cruises, the world leading cruise line installed onboard COVID PCR test laboratories
              on all on their ocean cruise ships. But Viking had no way of ensuring the refrigeration units required
              to keep essential testing chemicals at just the right temperature were always working 100%."
            solutionText="Raa Labs and their RaaEdge digital infrastructure made sure all refrigerators and freezers
              onboard Viking's vessels were constantly monitored. Using sensors speaking to the RaaEdge system,
              powered by LoraWAN, crew both onboard and onshore could now receive live data via dashboards and monitor
              the condition of the PCR chemicals. Viking Cruises is the first cruise liner to test all staff and guests
              every day of a cruise, with Raa Labs' technology and maritime knowledge helping make this a reality."
          />
          <WideCard
            image={printing3DImg}
            alt="Ship on the ocean"
            heading="3D printing"
            problemText="Based on current data, the maritime and offshore industry spends billions of dollars every
              year on spare parts; with a large portion of these vessels or offshore assets being more than
              a decade old, availability of parts are limited. This makes orders for often must-have maritime
              and offshore spare parts costly and complicated, with delivery costs often outweigh the cost of the part itself."
            solutionText="Combine our long-standing maritime service and supply know-how with thyssenkrupp’s deep
              expertise in additive manufacturing. The result is our unique Additive Manufacturing (AM) venture,
              which is helping maritime and offshore companies to cut lead times, improve part performance
              and solve parts obsolescence – while reducing the impact on the environment. Through a unique digitalisation
              and certification process, parts are produced on-demand, closer to the point of need."
          />
        </div>
        <div className="careers-page__info-headline">
          <h2>Selected products and services from the Wilhelmsen group</h2>
          <p>
            The largest one-stop digital manufacturing partner in the maritime
            and offshore industry with a one-of-a-kind fulfilment platform
            filling the gaps for much-needed spare parts
          </p>
        </div>
        <div className="careers-page__cta-cards">
          <CtaCard
            image={raaEdgeLogo}
            alt="Logo of RaaEdge"
            heading="RaaEdge"
            paragraph="A digital infrastructure giving the customer unique access to operational vessel data as a service, stored in the cloud."
            url="https://www.raalabs.com/raaedge-what-is-it"
          />
          <CtaCard
            image={lmpLogo}
            alt="Logo of LMP"
            heading="Line Management Plan"
            paragraph="A handy application that provides a complete overview of the mooring equipment and usage onboard."
            url="https://www.wilhelmsen.com/marine-products/digital-ventures-mp/line-management-plan/"
          />
          <CtaCard
            image={sparkLogo}
            alt="Spark text"
            heading="Spark"
            paragraph="Optimising fuel efficiency onboard is essential. This intuitive app helps users do just that."
            url="https://www.wilhelmsen.com/ship-management/technical-management/spark-by-wilhelmsen-ship-management/ "
          />
          <CtaCard
            image={printing3DLogo}
            alt="3D printing text"
            heading="3D printing"
            paragraph="A one of a kind 3D printing platform which helps wave goodbye to time-consuming and costly storage, shipping, customs, and receiving processes for spare parts."
            url="https://www.wilhelmsen.com/marine-products/digital-ventures-mp/3d-printing-Offering-A-Stronger-and-More-Resilient-Supply-Chain-for-Spare-Parts/"
            showLogos
          />
          <CtaCard
            image={nextOneLogo}
            alt="The next one"
            url="https://wilhelmsen.wd3.myworkdayjobs.com/Wilhelmsen"
            isLast
          />
        </div>
        <div className="careers-page__info-columns">
          <div>
            <h2>
              Working at <b>Wilhelmsen</b>, you have:
            </h2>
            <p>
              <b>Ownership</b> of your projects
              <br />
              Opportunity to influence your <b>tech stack</b> <br />{' '}
              <b>Autonomy</b> for you and your team <br />
              Flexible <b>hours and locations</b>
              <br />
              Extensive <b>development opportunities</b>
            </p>
          </div>
        </div>
        <div className="careers-page__people-gallery">
          <h2>Who we are...</h2>
          <p>
            We are a team of tech enthusiasts who thrive in an environment of
            ownership to our work. We use our unique skill sets to address real
            life challenges our customers are facing, providing value through
            the use of technology. We love developing new solutions in a
            traditional industry, making analogue vessels and equipment spring
            to digital life.
          </p>
          <p>
            Below are a few of our talents that worked on the case studies and
            products you have read about above.
          </p>
          <br />
          <div className="careers-page__people">
            <div className="careers-page__person">
              <img src={firstPersonImg} alt="Kristoffer Berge" />
              <p>
                Kristoffer, passionate about developing simple and
                easy-to-understand solutions that solve real world problems.
                When he's not thinking about how he can refactor code he enjoys
                trail running and sailing.
              </p>
            </div>
            <div className="careers-page__person">
              <img src={secondPersonImg} alt="Emil Ramsvik" />
              <p>
                Emil, loves understanding the details behind the data and
                creating models to help our users excel in their work.
                Passionate about Dev-Ops and how to remove obstacles and
                bottlenecks in the workflow.
              </p>
            </div>
            <div className="careers-page__person">
              <img src={thirdPersonImg} alt="Marita Lindstrom" />
              <p>
                Marita, dog-lover and ski enthusiast. Goes to sleep thinking
                about which of the backlog items would create the most
                delightful customer experience with Wilhelmsen.
              </p>
            </div>
            <div className="careers-page__person">
              <img src={fourthPersonImg} alt="Daniel Tan" />
              <p>
                Daniel, finds it amazing to work with evolving 3D printing
                technologies and its features. For example, he helped set up a
                cloud-based distributed manufacturing platform, implementing
                cryptographic cybersecurity encryption/decryption solutions to
                protect digital assets.
              </p>
            </div>
          </div>
          <h2>Our workplace and culture</h2>
          <p>
            Our work culture can be summarised in three words:{' '}
            <b> autonomy, flexibility and ownership</b>. We believe in guiding
            our digital teams only by strategic direction and context, viewing
            every team as central decision makers. We want you to realise your
            vision and therefore provide you with all the tools necessary to do
            so, trusting you with the autonomy and ownership to decide yourself
            how to best create value through your individual skill set.
          </p>
          <p>
            Additionally, we empower you as an individual through flexible
            working arrangements. This includes the freedom to explore
            opportunities, such as, digital product ownership, tools and
            programming languages, as well as the ability to shape your own
            position.
          </p>
        </div>
        <div className="careers-page__image-gallery">
          <div className="careers-page__image-group">
            <img
              src={galleryImageOne}
              alt="Torkil and Olga walking"
              style={{ width: 618 }}
            />
            <img
              src={galleryImageThree}
              alt="Marita sitting and smiling"
              style={{ width: 626 }}
            />
          </div>
          <div className="careers-page__image-group">
            <img
              src={galleryImageTwo}
              alt="Sitting in front of code"
              style={{ width: 725 }}
            />
            <img
              src={galleryImageFour}
              alt="Group sitting on couch, Magnus laughing"
              style={{ width: 707 }}
            />
          </div>
        </div>
        <div className="careers-page__footer">
          <div className="careers-page__footer-content">
            <p>Our head office is located at Lysaker near Oslo, Norway.</p>
            <p>
              Other hubs in the Wilhelmsen group include Singapore and Dubai,
              with more locations across the globe. In fact we have offices in
              over 60 countries.
            </p>
            <p>
              We work remote as well, seeing great ideas and content come to
              life no matter where you sit.
            </p>
          </div>
          <img src={officeImg} alt="Lysaker office" />
        </div>
      </div>
    );
  }
}
